<ul class="listing-st-1 licontentcenter nobefore">
    <li class="ptb15 order-txt" *ngFor="let service of dyServicesList; let i = index">
        <label class="cstcheckbox flmid fullspace w100 bold font16" (change)="getCheckboxValues($event,service)">
            <input name="additionalservice" [value]="service" [id]="i" [name]="service" [(ngModel)]="service.Checked"
                data-value="service?.ItemValue" type="checkbox" />
            <span></span>
            <abbr>{{service?.ItemDescription}}</abbr><strong class="font16 txtright">
              {{ service?.ItemValue | number:'1.2-2'}}
            </strong>
        </label>
    </li>
</ul>